export default __webpack_public_path__ + "static/media/Imperial Bluesteel Slaughter Steed.b5115379.jpg";